<template>
  <div class="const">
    <div class="const_left">
      <div class="kpDiv" isFullscreen>
        <img :src="kpPic" preview="0" preview-text="描述文字" width="100%" />
      </div>
      <div class="tpqp" v-if="fullscreenEl">
        <div class="close">
          <i
            class="el-icon-circle-close"
            style="color:#fff;font-size:40px"
            v-on:click="screenfull()"
          ></i>
        </div>
        <div class="center">
          <img :src="kpPic" />
        </div>
      </div>
      <div class="const_left_foter">
        <span
          v-on:mouseover="qpmsIcon = require('@/assets/sj_icon4.png')"
          v-on:mouseout="qpmsIcon = require('@/assets/sj_icon3.png')"
          v-on:click="screenfull()"
        >
          <label style="margin-right:8px; cursor: pointer;">全屏模式</label>
          <img :src="qpmsIcon" />
        </span>
      </div>
    </div>
    <div class="const_right">
      <h3>
        <label></label>视频设置
      </h3>
      <h4>清晰度：</h4>
      <div class="radioXx">
        <el-radio-group v-model="radio1" @change="changes()">
          <el-radio-button label="普通"></el-radio-button>
          <el-radio-button label="清晰"></el-radio-button>
          <el-radio-button label="高清"></el-radio-button>
        </el-radio-group>
      </div>
      <h4>分辨率：</h4>
      <div class="radioXx">
        <el-radio-group v-model="radio2" @change="changes()">
          <el-radio-button label="640*360"></el-radio-button>
          <el-radio-button label="800*450"></el-radio-button>
          <el-radio-button label="1280*720"></el-radio-button>
        </el-radio-group>
      </div>
      <h4>刷新率：</h4>
      <div class="radioXx">
        <el-radio-group v-model="radio3" @change="changes()">
          <el-radio-button label="3秒"></el-radio-button>
          <el-radio-button label="5秒"></el-radio-button>
          <el-radio-button label="10秒"></el-radio-button>
        </el-radio-group>
      </div>
      <div class="const_right_ts">注意：图像质量和分辨率参数越高，需要传输的数据量越大。如果图像传输时间过长，建议降低图形质量和分辨率。</div>
    </div>
  </div>
</template>
<script>
import { http } from "./../../https";
import { setInterval, clearInterval } from "timers";
export default {
  data() {
    return {
      radio1: "普通",
      radio2: "640*360",
      radio3: "5秒",
      kpPic: "",
      qpmsIcon: require("@/assets/sj_icon3.png"),
      int: null,
      fullscreenEl: false //关闭全屏按钮
    };
  },
  created() {
    this.pmjk();
    let speen = 0;
    if (this.radio3 == "3秒") {
      speen = 3000;
    } else if (this.radio3 == "5秒") {
      speen = 5000;
    } else if (this.radio3 == "10秒") {
      speen = 10000;
    }
    this.int = setInterval(this.pmjk, speen);
  },
  beforeDestroy() {
    clearInterval(this.int);
  },
  methods: {
    pmjk() {
      const user_name = sessionStorage.getItem("user_name");
      const mac = sessionStorage.getItem("mac");
      let macSplit = mac.replace(/-/g, "");
      let picZl = 0;
      let picWidth = 0;
      if (this.radio1 == "普通") {
        picZl = 30;
      } else if (this.radio1 == "清晰") {
        picZl = 60;
      } else if (this.radio1 == "高清") {
        picZl = 100;
      }
      if (this.radio2 == "640*360") {
        picWidth = 640;
      } else if (this.radio2 == "800*450") {
        picWidth = 800;
      } else if (this.radio2 == "1280*720") {
        picWidth = 1280;
      }
      let url = `http://${user_name}_${macSplit}.ng.360mon.cn:90/index.php?class=record&act=getRealScreen&quality=${picZl}&resolution=${picWidth}`;
      http({
        method: "GET",
        url: url,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      })
        .then(res => {
          this.kpPic = `http://${user_name}_${macSplit}.ng.360mon.cn:90/${res.data.img}`;
        })
        .catch(res => {
          console.log(res);
        });
    },
    changes() {
      if (this.int != "" && this.int != null) {
        clearInterval(this.int);
      }
      let speen = 0;
      if (this.radio3 == "3秒") {
        speen = 3000;
      } else if (this.radio3 == "5秒") {
        speen = 5000;
      } else if (this.radio3 == "10秒") {
        speen = 10000;
      }
      this.int = setInterval(this.pmjk, speen);
    },
    // 全屏模式 将方法绑定(点击事件)到页面的元素上即可
    screenfull() {
      this.fullscreenEl = !this.fullscreenEl;
    }
  }
};
</script>
<style scoped>
.tpqp {
  position: fixed;
  background: rgba(000, 000, 000, 0.8);
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 99999999999999;
}
.tpqp .close {
  text-align: right;
  margin-top: 40px;
  margin-right: 40px;
  cursor: pointer;
}
.tpqp .center {
  display: flex;
  height: 100%;
  margin-top: -40px;
  align-items: center;
  justify-content: center;
}
.tpqp img {
  width: 1200px;
}
.const {
  background: #ffffff;
  height: 100%;
  width: 100%;
  border-radius: 8px;
  display: flex;
  justify-content: center;
}
.const .const_left {
  width: calc(100vw - 552px);
  height: calc(100vh - 290px);
  background-size: 100% 100%;
  margin-top: 20px;
  margin-left: 20px;
  position: relative;
}
.const .const_left .kpDiv {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.const .const_left .const_left_foter {
  padding: 12px 0px;
  position: absolute;
  width: 100%;
  bottom: 0px;
  text-align: center;
  background: #000;
  opacity: 0.6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.const .const_left .const_left_foter span {
  margin-right: 20px;
  cursor: pointer;
}
.const .const_left .const_left_foter span img {
  vertical-align: middle;
  margin-top: -5px;
}
.const .const_right {
  text-align: left;
  margin-left: 20px;
  width: 382px;
  margin-right: 20px;
}
.const .const_right h3 {
  margin: 18px 0 0 0;
  font-size: 15px;
  font-weight: bold;
  text-align: left;
  color: rgba(70, 70, 70, 1);
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 10px;
}
.const .const_right h3 label {
  border-left: 5px solid #2878ff;
  margin-right: 6px;
}
.const .const_right h4 {
  margin-top: 19px;
  font-size: 13px;
  font-weight: 400;
  color: rgba(123, 123, 123, 1);
}
.const .const_right .radioXx {
  margin-top: 16px;
}
.const .const_right .const_right_ts {
  margin-top: 36px;
  padding-top: 16px;
  border-top: 1px solid #e8e8e8;
  font-size: 14px;
  font-weight: 400;
  color: rgba(167, 167, 167, 1);
  line-height: 24px;
}
</style>